import { useAppSelector } from 'src/store/store';
import { isUsingT2Experience } from 'src/utils/jmrUtils';

const useIsT2Experience = () => {
  const { featureFlags, ldap } = useAppSelector((state) => state.user);
  const { backgroundFormData, t2AdminToggle } = useAppSelector((state) => state.newJmrPage);
  return isUsingT2Experience(featureFlags, ldap, backgroundFormData?.jobLevel, t2AdminToggle);
};

export default useIsT2Experience;
